export default "__VITE_ASSET__Blucca5o__"